<template>
  <SysDialog
    v-model="dialog"
    titulo="Filial de destino X Filiais de origem"
    @click:primary="salvarDados()"
    @click:hidden-dialog="limparDados()"
  >
    <template #ativador>
      <v-btn color="primary" @click="abrirDialog()">NOVO</v-btn>
    </template>

    <v-autocomplete
      v-model="dados.grupos_separacao"
      :items="selects.grupos_separacao"
      label="Grupos de Separação"
      outlined
      item-value="id"
      item-text="descricao"
      :error-messages="GRUPO_SEPARACAO_ERRORS"
      @input="$v.dados.grupos_separacao.$touch()"
    />

    <v-autocomplete
      v-model="dados.filial_destino"
      :items="selects.filiais_grupo_separacao"
      label="Filial Destino"
      item-text="nome_filial"
      item-value="filial"
      outlined
      :error-messages="FILIAL_DESTINO_ERROS"
      @input="$v.dados.filial_destino.$touch()"
    />

    <DivisorComLegenda legenda="Filiais de origem e parametrização" class="mb-6" />

    <v-row v-for="(vl, idx) in dados.filial_origem" :key="idx">
      <v-col>
        <SysFilialGrupoAutocomplete
          v-model="vl.filial"
          :filiais_para_ocultar="ocultarFiliaisSelecionadas(idx)"
          label="Filial Origem"
          item-text="filial"
          item-value="filial"
          outlined
          hide-details
          multiple
          :error-messages="getObjectErrorMessages('filial', idx)"
        />
      </v-col>

      <v-col class="px-0">
        <TextFieldFormatadorDeValor
          v-model="vl.cobertura_drp"
          label="Cobertura de Estoque"
          outlined
          hide-details
          suffix="dias"
          :removerValorIrrelevante="true"
          :error-messages="getObjectErrorMessages('cobertura_drp', idx)"
        />
      </v-col>

      <v-col>
        <TextFieldFormatadorDeValor
          v-model="vl.tempo_ressuprimento_drp"
          label="Tempo de Ressuprimento"
          outlined
          hide-details
          suffix="dias"
          :removerValorIrrelevante="true"
          :error-messages="getObjectErrorMessages('tempo_ressuprimento_drp', idx)"
        />
      </v-col>

      <v-btn icon @click="removerFilialOrigem(idx)" class="my-auto" v-if="FILIAL_ORIGEM_LENGH > 1">
        <v-icon color="red">mdi-minus</v-icon>
      </v-btn>
    </v-row>

    <v-btn icon class="mt-2" color="primary" @click="adicionarFilialOrigem()">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </SysDialog>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysFilialGrupoAutocomplete from "@/components/utils/crud/SysFilialGrupoAutocomplete";
import TextFieldFormatadorDeValor from "@/components/utils/TextFieldFormatadorDeValor.vue";
import { getGrupoSeparacao, storeMapaSeparacao, getFiliaisGrupoSeparacao } from './Requisicoes';
import { required } from "vuelidate/lib/validators";
import DivisorComLegenda from "@/components/utils/DivisorComLegenda.vue";

export default {
  components: {DivisorComLegenda, SysDialog, SysFilialGrupoAutocomplete, TextFieldFormatadorDeValor },
  data: ()=> ({
    dialog: false,
    dados: {
      grupos_separacao: [],
      filial_destino: '',
      filial_origem: [
        { filial: [], cobertura_drp: 30, tempo_ressuprimento_drp: 5 }
      ],
    },
    selects: {
      grupos_separacao: [],
      filiais_grupo_separacao: []
    },
    filiais: []
  }),
  mounted() {
    this.buscarGruposDeSeparacao();
  },
  watch: {
    "dados.grupos_separacao"(valor) {
      if (valor) this.buscarFiliaisGruposDeSeparacao(valor);
    }
  },
  computed: {
    GRUPO_SEPARACAO_ERRORS () {
      const errors = [];
      if (!this.$v.dados.grupos_separacao.$dirty) return errors;
      !this.$v.dados.grupos_separacao.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_DESTINO_ERROS () {
      const errors = [];
      if (!this.$v.dados.filial_destino.$dirty) return errors;
      !this.$v.dados.filial_destino.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    FILIAL_ORIGEM_LENGH() {
      return this.dados.filial_origem.length;
    }
  },
  methods: {
    ocultarFiliaisSelecionadas(idx) {
      if (idx == 0) return;

      let ocultar_filiais = [];

      for (let index = 0; index <= (idx - 1); index++) {
        ocultar_filiais.push(...this.dados.filial_origem[index].filial);
      }

      return ocultar_filiais;
    },
    getObjectErrorMessages(fieldName, index) {
      const objectErrors = this.$v.dados.filial_origem;
      if (!objectErrors || !objectErrors.$each || !objectErrors.$each[index]) {
        return [];
      }

      const fieldErrors = objectErrors.$each[index][fieldName];
      if (!fieldErrors || !fieldErrors.$error) {
        return [];
      }

      return fieldErrors.$dirty ? [fieldErrors.$error] : [];
    },
    removerFilialOrigem(idx) {
      if (this.FILIAL_ORIGEM_LENGH == 1) return;
      this.dados.filial_origem.splice(idx, 1);
    },
    adicionarFilialOrigem() {
      this.dados.filial_origem.push({ filial: [], cobertura_drp: 30, tempo_ressuprimento_drp: 5 });
    },
    salvarDados() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      this.$store.dispatch(
        "loading/addRequisicao",
        storeMapaSeparacao(this.dados)
          .then(() => {
            this.fecharDialog();
            this.limparDados();
            this.$emit('atualizar-tela-inicial');
          })
          .catch(() => this.Helpers.logout())
      );
    },
    buscarGruposDeSeparacao() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getGrupoSeparacao().then(grupos => this.selects.grupos_separacao = grupos).catch(() => this.Helpers.logout())
      );
    },
    buscarFiliaisGruposDeSeparacao(grupo) {
      this.$store.dispatch(
        "loading/addRequisicao",
        getFiliaisGrupoSeparacao(grupo)
          .then(filiais => this.selects.filiais_grupo_separacao = filiais)
          .catch(() => this.Helpers.logout())
      );
    },
    abrirDialog() {
      this.dialog = true;
    },
    fecharDialog() {
      this.dialog = false;
    },
    limparDados() {
      this.dados.grupos_separacao = '';
      this.dados.filial_destino = '';
      this.dados.filial_origem = [{ filial: [], cobertura_drp: 30, tempo_ressuprimento_drp: 5 }];
      this.$v.$reset();
    }
  },
  validations: {
    dados: {
      grupos_separacao: { required },
      filial_destino: { required },
      filial_origem: {
        $each: {
          filial: { required },
          cobertura_drp: { required },
          tempo_ressuprimento_drp: { required }
        }
      }
    }
  },
}
</script>

<style>

</style>
